import { NumericDataTypeIcon, DateDataTypeIcon, EnumerationDataTypeIcon, TextDataTypeIcon, FileIcon, DataSyncIcon, ServerlessFunctionIcon, CodeIcon } from 'foundations-assets';
export const fieldTypeIcons = {
  text: TextDataTypeIcon,
  textarea: TextDataTypeIcon,
  html: CodeIcon,
  phonenumber: NumericDataTypeIcon,
  number: NumericDataTypeIcon,
  date: DateDataTypeIcon,
  booleancheckbox: EnumerationDataTypeIcon,
  checkbox: EnumerationDataTypeIcon,
  radio: EnumerationDataTypeIcon,
  select: EnumerationDataTypeIcon,
  calculation_equation: ServerlessFunctionIcon,
  calculation_rollup: DataSyncIcon,
  calculation_score: ServerlessFunctionIcon,
  file: FileIcon
};
export const fieldTypeMessages = {
  text: 'customerDataFiltersUI.fieldType.singleLineText',
  textarea: 'customerDataFiltersUI.fieldType.multiLineText',
  html: 'customerDataFiltersUI.fieldType.richText',
  phonenumber: 'customerDataFiltersUI.fieldType.phoneNumber',
  number: 'customerDataFiltersUI.fieldType.number',
  date: 'customerDataFiltersUI.fieldType.date',
  booleancheckbox: 'customerDataFiltersUI.fieldType.singleCheckbox',
  checkbox: 'customerDataFiltersUI.fieldType.multipleCheckboxes',
  radio: 'customerDataFiltersUI.fieldType.radio',
  select: 'customerDataFiltersUI.fieldType.dropdownSelect',
  calculation_equation: 'customerDataFiltersUI.fieldType.calculation',
  calculation_rollup: 'customerDataFiltersUI.fieldType.rollup',
  calculation_score: 'customerDataFiltersUI.fieldType.score',
  file: 'customerDataFiltersUI.fieldType.file'
};
export const hasFieldTypeMessage = s => {
  return s in fieldTypeMessages;
};